<template>
    <div class="category-staff">
        <v-page-header
            :title="`${group.title}(${group.app_infos.length})`"
            level="section"
        />
        <template v-if="showTextRobots">
            <div class="staff-title--sub">
                文本机器人应用（{{ textRobots.length }}）
            </div>
            <div class="category-staff-list category-staff-list--text">
                <div
                    v-for="(app,i) of textRobots"
                    :key="app.app_id"
                    class="category-staff-list-item"
                    @click="staffClick(app, true)"
                >
                    <div class="category-staff-list-item-info">
                        <div
                            :class="!app.avatar? bgmColor[i] :''"
                            class="category-staff-list-item-icon"
                        >
                            <img
                                v-if="app.avatar"
                                :src="app.avatar"
                                class="category-staff-list-item-icon-img"
                                width="50"
                                height="50"
                                alt=""
                            >
                            <span
                                v-else-if="!app.avatar"
                                class="category-staff-list-item-icon-text"
                            >{{ getIconName(app.app_name) }}</span>
                        </div>
                        <div class="category-staff-list-item-content">
                            <div class="category-staff-list-item-name">
                                {{ app.app_name }}
                            </div>
                            <div
                                v-if="app.desc"
                                class="category-staff-list-item-desc"
                            >
                                {{ app.desc }}
                            </div>
                        </div>
                    </div>
                    <div
                        class="category-staff-list-item-details"
                    >
                        <div class="category-staff-list-item-details-left">
                            <div class="detail-left__top">
                                <span
                                    class="category-staff-list-item-details-txt"
                                >有效期</span>
                                <p
                                    v-if="app.robot_err_reason"
                                    class="detail-text__tip"
                                >
                                    <span class="category-staff-list-item-details-left-icon" />
                                    <span class="category-staff-list-item-details-left-expire">
                                        {{ app.robot_err_reason }}
                                    </span>
                                </p>
                            </div>
                            <p class="category-staff-list-item-details-txt">
                                {{ getRobotTime(app.robot_create_time) }}~{{ getRobotTime(app.robot_expire_time) }}
                            </p>
                        </div>
                        <span class="line" />
                        <div class="category-staff-list-item-details-right">
                            <p
                                class="category-staff-list-item-details-txt"
                                style="margin-bottom:6px"
                            >
                                机器人消息数
                            </p>
                            <p class="category-staff-list-item-details-txt">
                                已用{{ Number(app.robot_used_msg_count).toLocaleString() }} / 剩余{{ Number(app.robot_unused_msg_count).toLocaleString() }}
                            </p>
                        </div>
                    </div>
                    <div
                        v-if="app.status === 0"
                        class="category-staff-list-item-status"
                    >
                        未安装
                    </div>
                    <div
                        v-else-if="app.status === 2"
                        class="category-staff-list-item-status category-staff-list-item-status--error"
                    >
                        安装失败
                    </div>
                </div>
            </div>
        </template>
        <template>
            <div class="staff-title--sub">
                大模型机器人应用（{{ bigModelRobots.length }}）
            </div>
            <div class="category-staff-list">
                <div
                    :class="{ 'robot-card--disabled': !hasBigModelPermission || remaining <= 0 }"
                    class="robot-card--active"
                >
                <v-tip ref="disabledTip" placement="top">
                    无创建权限，如有需要请联系管理者
                </v-tip>
                    <div v-if="!hasBigModelPermission" v-tip:disabledTip.hover class="robot-card__btn">
                        <v-icon
                            name="basic_add_fill"
                            remote
                        />
                        新建应用
                    </div>
                    <div v-else class="robot-card__btn" @click="openDlg(true)">
                        <v-icon
                            name="basic_add_fill"
                            remote
                        />
                        新建应用
                    </div>
                    <div class="robot-card__types">
                        已用{{ bigModelRobots.length }}/剩余{{ remaining }}
                    </div>
                </div>
                <div
                    v-for="(app,i) of bigModelRobots"
                    :key="app.app_id"
                    class="category-staff-list-item"
                    @click="staffClick(app, true)"
                >
                    <div class="category-staff-list-item-info">
                        <div
                            :class="!app.avatar? bgmColor[i] :''"
                            class="category-staff-list-item-icon"
                        >
                            <img
                                v-if="app.avatar"
                                :src="app.avatar"
                                class="category-staff-list-item-icon-img"
                                width="48"
                                height="48"
                                alt=""
                            >
                            <span
                                v-else-if="!app.avatar"
                                class="category-staff-list-item-icon-text"
                            >{{ getIconName(app.app_name) }}</span>
                        </div>
                        <div class="category-staff-list-item-content">
                            <div class="category-staff-list-item-name">
                                {{ app.app_name }}
                            </div>
                            <div
                                class="category-staff-list-item-robot"
                            >
                                <span class="category-staff-list-item-robot-name">机器人-{{ robotName(app.robot_name) }}</span>
                                <v-button v-if="!hasBigModelPermission" v-tip:updateTip.hover type="link" kind="primary" disabled>
                                    更换
                                </v-button>
                                <v-button v-else type="link" kind="primary" @click="openDlg(false, app)">
                                    更换
                                </v-button>
                                <v-tip ref="updateTip" placement="top">
                                    无更换权限
                                </v-tip>
                            </div>
                        </div>
                    </div>
                    <div
                        class="category-staff-list-item-details"
                    >
                        <div class="category-staff-list-item-details-right-btn">
                            <div v-if="app.status === 1" class="detail-right__top">
                                <v-button kind="primary" @click="staffClick(app, true, 'appSetting')">
                                应用设置
                                </v-button>
                                <v-button @click="staffClick(app, true, 'robot')">
                                机器人设置
                                </v-button>
                            </div>
                            <div v-else class="detail-right__top">
                                <v-button kind="primary" @click="goAppStall">
                                重试安装
                                </v-button>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="app.status === 0"
                        class="category-staff-list-item-status"
                    >
                        未安装
                    </div>
                    <div
                        v-else-if="app.status === 2"
                        class="category-staff-list-item-status category-staff-list-item-status--error"
                    >
                        安装失败
                    </div>
                </div>
            </div>
        </template>
        <BigRobotCreate
            ref="createRef"
            :robot-types="bigRobotTypes"
            @afterCreate="afterCreate"
        />
        <AssociateRobot
            ref="associateRef"
            :title="isCreate ? '创建应用' : '更换关联机器人'"
            model="form"
            @submit="submit"
        >
        <div v-if="isCreate" slot="customOptions" :class="{'is-disabled': !canCreateBigRobot}" @click="goCreate">
            <v-tip ref="disabledBtn" placement="top-start">
                机器人已达上限
            </v-tip>
            <div v-if="!canCreateBigRobot" v-tip:disabledBtn.hover>
                新建机器人
            </div>
            <div v-else>
                新建机器人
            </div>
        </div>
    </AssociateRobot>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import Gateway from '@/utils/Gateway';
import BigRobotCreate from './BigRobotCreate.vue';
import AssociateRobot from '@/components/associate-robot';
import cookie from '@/utils/cookie';

const DISABLE_CLICK_BIG_ROBOT_STATUS = [2, 10, 8];
const CREATE_APP_URL = '/v1/wework/staff/recordCidRidMapping';
const UPDATE_ROBOT_URL = '/v1/wework/staff/robotMappingSwitch';

export default {
    name: 'AppCategoryStaff',
    components: {
        BigRobotCreate,
        AssociateRobot,
    },
    props: {
        group: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            iconName: '',
            bgmColor: [
                'bgm-blue',
                'bgm-orange',
                'bgm-yellow',
            ],
            showBigRobots: false,
            bigRobotTypes: [],
            packageInfo: {},
            hasBigModelPermission: false,
            isCreate: false,
            canCreateBigRobot: true,
            currentApp: {},
        };
    },
    computed: {
        remaining() {
            return 10 - this.bigModelRobots.length - this.textRobots.length;
        },
        textRobots() {
            const robots = this.group.app_infos || [];
            const result = robots.filter(({ chat_gpt_type: gptType }) => +gptType !== 1);
            return result;
        },
        showTextRobots() {
            return this.textRobots && this.textRobots.length > 0;
        },
        bigModelRobots() {
            const robots = this.group.app_infos || [];
            const result = robots.filter(({ chat_gpt_type: gptType }) => +gptType === 1);
            return result;
        },
    },
    created() {
        this.initRobotLicense();
        this.initPackageInfo();
        this.checkHasConsumptionPermission();
    },
    methods: {
        goAppStall() {
            window.location.href = '/mng/weworkAccount/index/app';
        },
        staffClick(config, isStaff, jumpUrl) {
            // 大模型机器人状态不正常，禁止跳转
            const { chat_gpt_type: isGpt, robot_status: robotStatus } = config;
            if (+isGpt === 1 && DISABLE_CLICK_BIG_ROBOT_STATUS.includes(+robotStatus)) return;
            this.$emit('click', config, isStaff, jumpUrl);
        },
        getIconName(e) {
            return e.slice(0, 2);
        },
        robotName(val) {
            if (val) {
                return val.length > 12 ? `${val.slice(0, 12)}...` : val;
            }
        },
        openDlg(isCreate, app) {
            if (this.remaining <= 0 && isCreate) return;
            this.isCreate = isCreate;
            this.currentApp = app;
            this.$refs.associateRef?.open(app?.robot_id);
        },
        submit(val) {
            const url = this.isCreate ? CREATE_APP_URL : UPDATE_ROBOT_URL;
            let params = {};
            if (this.isCreate) {
                params = {
                    robot_id: val,
                };
            } else {
                params = {
                    robot_id: val,
                    suite_id: this.currentApp.app_id,
                };
            }
            this.$ajax.gatewayPost(url, params).then((res) => {
                this.$emit('update');
            })
            .catch((err) => {
                this.$message.error(err.message || '操作失败');
            });
        },
        getRobotTime(e) {
            return dayjs(e * 1000).format('YYYY.MM.DD');
        },
        goCreate() {
            if (!this.canCreateBigRobot) return;
            this.$refs.associateRef.close();
            this.$refs.createRef.open();
        },
        afterCreate() {
            // 大模型机器人创建成功后跳转应用安装界面
            window.location.href = '/mng/weworkAccount/index/app';
        },
        initRobotLicense() {
            Gateway.get('/v1/robotConf/robot/license/list', { sceneType: 3, kfext: 0 })
                .then(({ licenseInfo: { canCreateFlag, licenses } = {} }) => {
                    const flag = this.bigModelRobots && this.bigModelRobots.length > 0;
                    this.canCreateBigRobot = !!canCreateFlag;
                    this.bigRobotTypes = licenses;
                    this.showBigRobots = flag || this.canCreateBigRobot;
                })
                .catch(message => this.$message.error(message || '获取机器人套餐数据失败'));
        },
        initPackageInfo() {
            // 找不到主号就不请求
            if (!cookie.get('corp_uin')) return;
            const params = {
                biz_type: 'BizType_QD_Robot_Model',
                acct_type: 'AccountType_Postpaid',
                // 套餐包id，
                package_ids: [10],
            };
            Gateway.get('/v1/finance/balance', params)
                .then(({ package_balances: packages = [] }) => {
                    this.packageInfo = { remainingNum: packages.reduce((prev, curr) => (prev + curr.num), 0) };
                })
                .catch(message => this.$message.error(message || '获取机器人套餐数据失败'));
        },
        navToConsumptionDetail() {
            window.location.href = '/cl/account/details/audioVideoDetail?title=robot';
        },
        checkHasConsumptionPermission() {
            // 16:消耗明细权限
            Gateway.get('/v1/account/privileges')
                .then((res) => {
                    const adminPrivileges = res.adminPrivileges || [];
                    this.hasBigModelPermission = adminPrivileges.includes(134) && adminPrivileges.includes(135);
                });
        },
    },
};
</script>

<style lang="less">
.category-staff {
    margin-top: 40px;
    .ellpsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    &-title {
        display: flex;
        padding: var(--spacing-loose) var(--spacing-none);
        align-items: center;

        color: var(--color-text-primary);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;

        .staff-title {
            &__box {
                display: flex;
                padding: var(--spacing-tight) var(--spacing-none);
                align-items: center;
                gap: var(--spacing-tight);
                flex: 1 0 0;
            }
            &__line {
                width: 2px;
                height: var(--size-xs);

                border-radius: 9px;
                background: var(--color-primary-normal);
            }
        }
    }
    &-list {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 20px;
        &-item {
            box-sizing: border-box;
            position: relative;
            padding: 38px 0px 29px 32px;
            width: 400px;
            height: 200px;

            background: #ffffff;
            border: 1px solid var(--border---color-border-normal, #E0E2E7);
            border-radius: 4px;
            cursor: pointer;
            transition: box-shadow 0.18s;
            background-image: url('../../assets/vector.png');
            background-repeat: no-repeat;
            background-position: right bottom;
            &:hover {
                box-shadow: 0px 1px 15px rgba(30, 36, 49, 0.15);
            }
            &-icon {
                width: 48px;
                height: 48px;
                flex-shrink: 0;
                border-radius: 6px;
                text-align: center;

                &-img {
                    border-radius: 6px;
                    text-indent: 100%;
                    overflow: hidden;
                    // background-image: url(../../assets/ic_default@8x.png);
                    background-size: cover;
                }
                &-text {
                  font-size: 16px;
                  color: #FFFFFF;
                  margin: 13px 8px;
                  display: inline-block;
                }
            }
            &-name {
                height: 25px;
                line-height: 25px;
                font-weight: 600;
                font-size: 18px;
                color: #000;
                .ellpsis();
            }
            &-desc {
                margin-top: 5px;
                line-height: 18px;
                color: #000;
                font-weight: 500;
                font-size: 13px;
                color: #a8abb3;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            &-robot {
                color: var(--text---color-text-secondary, var(--color-gray-8));
                &-name {
                    margin-right: var(--spacing-loose);
                }
            }
            &-status {
                position: absolute;
                right: 0;
                top: 0;
                padding: 5px 10px;

                display: inline-flex;
                justify-content: center;
                align-items: center;

                border-radius: 0 4px 0 4px;
                background: #C5CCDB;

                color: var(--color-text-white);
                text-align: justify;
                font-family: "PingFang SC";
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 20px;
                &--error {
                    background-color: var(--color-error-light-active);
                }
            }
            &-info {
              display: inline-flex;
              align-items: center;
              gap: var(--spacing-base-loose);
              margin-bottom: 39px;
            }
            &-details {
              display: flex;
              align-items: center;
              gap: 20px;
              &-txt {
                font-size: 14px;
                line-height: 20px;
                color: #5B5F70;
              }
              &-left {
                &.list-item__left--auto {
                    width: auto;
                }
                &-icon {
                  width: 12px;
                  height: 12px;
                  background-image: url('../../assets/warn.png');
                  background-size: 100%;
                  background-repeat: no-repeat;
                  display: inline-block;
                  margin: 0 4px 0px 8px;
                }
                &-expire {
                  font-size: 12px;
                  line-height: 16px;
                  color: #ff4222;
                }
              }
              &-right-btn {
                position: absolute;;
                bottom: 20px;
                right: 32px;
                .detail-right__top {
                    display: flex;
                    gap: var(--spacing-loose);
                }
              }
            }
        }
        &.category-staff-list--text {
            margin-bottom: 30px;
        }
        .robot-card {
            &--active {
                box-sizing: border-box;

                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                align-self: stretch;
                gap: 20px;

                width: 400px;
                height: 200px;

                border-radius: 4px;
                border: 1px solid var(--border---color-border-normal, #E0E2E7);

                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;

                &:hover {
                    cursor: pointer;
                }
            }
            &__btn {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 8px;

                color: var(--primary---color-primary-normal, #4A70FF);

                .v-icon {
                    width: 24px;
                    height: 24px;
                }
            }
            &__types {
                color: var(--color-text-primary);
                line-height: 20px;
            }
        }
    }
    .line {
      height: 36px;
      width: 1px;
      display: inline-block;
      background: #ECEEF1;
    }
    .bgm-blue {
      background: #4A70FF;
    }
    .bgm-orange {
      background: #FF8345;
    }
    .bgm-yellow {
      background: #F7C51E;
    }
    .staff-title--sub {
        padding: var(--spacing-base) var(--spacing-none);

        color: #1E2330;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
    }
    .detail-text__tip {
        display: inline-flex;
        align-items: center;
    }
    .detail-left__top {
        display: flex;
        align-items: center;
        margin-bottom: 6px;
    }
    .robot-card--disabled {
        user-select: none;
        cursor: default !important;
        .robot-card__btn {
            color: var(--color-text-disable);
        }
    }
    .section__card {
        display: flex;
        margin-bottom: 20px;
        padding: var(--spacing-loose);
        align-items: flex-end;
        gap: var(--spacing-loose);
        justify-content: space-between;
        width: 50%;

        border-radius: var(--radius-large);
        border: 1px solid var(--color-divider-normal);
        background: var(--color-bg-1);
        .card {
            &--left {
                display: flex;
                padding: var(--spacing-none);
                flex-direction: column;
                align-items: flex-start;
                gap: 8px;
                flex: 1 0 0;
                .count {
                    &__usage {
                        color: var(--color-text-primary);

                        /* number/--number-normal-medium */
                        font-family: Inter;
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 32px; /* 133.333% */
                    }
                    &__gap {
                        color: var(--color-text-caption);

                        /* regular/--headline1-regular */
                        font-family: PingFang SC;
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 28px; /* 140% */
                    }
                    &__total {
                        color: var(--color-text-primary);
                        font-family: Inter;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 24px; /* 150% */
                    }
                    &__unit {
                        color: var(--color-text-caption);
                        font-family: PingFang SC;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 22px; /* 157.143% */
                    }
                }
            }
            &__label {
                color: var(--color-text-caption);

                /* regular/--body1-regular */
                font-family: PingFang SC;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 22px; /* 157.143% */
            }
        }
    }
}
</style>
